import React from "react";
import cn from "classnames";

const TripleHeroComponent = ({
    state: {
        hero1Url = "",
        hero1Heading = "Hero 1",
        hero1ButtonLink = "",
        hero2Url = "",
        hero2Heading = "Hero 2",
        hero2ButtonLink = "",
        hero3Url = "",
        hero3Heading = "Hero 3",
        hero3ButtonLink = "",
    },
    isEditMode,
    onChange,
    focused,
}) => {
    return (
        <div className="flex flex-col lg:flex-row lg:aspect-[1440/700] bg-brand-dark-grey">
            <div className="flex-1 relative flex justify-center items-center aspect-[375/220] lg:aspect-auto">
                <div className="flex flex-col z-10 items-start">
                    {hero1Heading && (
                        <h1
                            className={cn(
                                `!text-[30px] !leading-[36px] lg:!text-[40px] lg:!leading-[46px] text-brand-white`,
                            )}
                        >
                            {hero1Heading}
                        </h1>
                    )}
                </div>

                {hero1Url && (
                    <img
                        src={hero1Url}
                        className="absolute top-0 left-0 w-full h-full object-cover"
                        alt="Hero Background"
                    />
                )}

                {hero1ButtonLink && (
                    <a
                        href={hero1ButtonLink}
                        onClick={(e) => {
                            e.preventDefault();
                            if (isEditMode) {
                                return;
                            } else {
                                window.location.href = hero1ButtonLink;
                            }
                        }}
                        className="opacity-0 absolute top-0 left-0 w-full h-full"
                    >
                        {hero1ButtonLink}
                    </a>
                )}
            </div>

            <div className="flex-1 relative flex justify-center items-center aspect-[375/220] lg:aspect-auto">
                <div className="flex flex-col z-10 items-start">
                    {hero2Heading && (
                        <h1
                            className={cn(
                                `!text-[30px] !leading-[36px] lg:!text-[40px] lg:!leading-[46px] text-brand-white`,
                            )}
                        >
                            {hero2Heading}
                        </h1>
                    )}
                </div>

                {hero2Url && (
                    <img
                        src={hero2Url}
                        className="absolute top-0 left-0 w-full h-full object-cover"
                        alt="Hero Background"
                    />
                )}

                {hero2ButtonLink && (
                    <a
                        href={hero2ButtonLink}
                        className="opacity-0 absolute top-0 left-0 w-full h-full"
                        onClick={(e) => {
                            e.preventDefault();
                            if (isEditMode) {
                                return;
                            } else {
                                window.location.href = hero2ButtonLink;
                            }
                        }}
                    >
                        {hero2ButtonLink}
                    </a>
                )}
            </div>

            <div className="flex-1 relative flex justify-center items-center aspect-[375/220] lg:aspect-auto">
                <div className="flex flex-col z-10 items-start">
                    {hero3Heading && (
                        <h1
                            className={cn(
                                `!text-[30px] !leading-[36px] lg:!text-[40px] lg:!leading-[46px] text-brand-white`,
                            )}
                        >
                            {hero3Heading}
                        </h1>
                    )}
                </div>

                {hero3Url && (
                    <img
                        src={hero3Url}
                        className="absolute top-0 left-0 w-full h-full object-cover"
                        alt="Hero Background"
                    />
                )}

                {hero3ButtonLink && (
                    <a
                        href={hero3ButtonLink}
                        className="opacity-0 absolute top-0 left-0 w-full h-full"
                        onClick={(e) => {
                            e.preventDefault();
                            if (isEditMode) {
                                return;
                            } else {
                                window.location.href = hero3ButtonLink;
                            }
                        }}
                    >
                        {hero3ButtonLink}
                    </a>
                )}
            </div>
        </div>
    );
};

export default TripleHeroComponent;
